@if (mode === AssessablePanelMode.Edit) {
	@if (inEditMode) {
		<div class="inputForNote" [@zoomInOnEnter]>
			<mat-form-field color="accent" class="full-width-form">
				<mat-icon matPrefix fontSet="fad" fontIcon="fa-comment-alt" />
				<mat-label>{{ T.ASSESSABLE_ITEM_NOTE | translate }}</mat-label>
				<sim-rich-text-editor-control [formControl]="from" />
			</mat-form-field>
		</div>
	} @else {
		<button
			mat-button
			color="accent"
			class="noteBtn"
			[class.grow]="!!value"
			matTooltip="{{ T.SHARED_EXPANSION_EDIT_ADD_NOTE | translate }}"
			matTooltipClass="accent"
			[@zoomInOnEnter]
			(click)="onNoteButtonClick.emit()"
			[disabled]="!canEnterEditMode"
		>
			<!-- do not move this icon inside the @if, the mat-button behaves differently for some reason if the icon is inside the @if -->
			<mat-icon inline class="icon" fontSet="fad" [fontIcon]="value ? 'fa-comment-alt' : 'fa-comment-alt-plus'" />

			@if (value) {
				<sim-rich-text-editor-view [@zoomInOnEnter] [content]="value" />
			} @else {
				{{ T.ASSESSABLE_ITEM_ADD_NOTE | translate }}
			}
		</button>
	}
} @else if (value) {
	<div class="noteText">
		<mat-icon inline class="icon" fontSet="fad" fontIcon="fa-info-circle" />
		<sim-rich-text-editor-view [@zoomInOnEnter] [content]="value" />
	</div>
}
